<template>
    <div class="school-alert-main">
      <transition name="alert">
        <div class="box school" v-if="alertData.show && alertData.type === 'school'">
          <input type="file" class="up-input" ref="upSchoolInput" accept="image/*" @change="upInputChange">
          <div class="school-title">
            <span>添加校徽</span>
            <span class="iconfont iconclose" @click="close"></span>
          </div>
          <div class="school-name margin-top-29">校徽库<span>（收录了国内 985 211学校校徽）</span></div>
          <div class="school-input">
            <el-autocomplete
              class="inline-input"
              v-model="name"
              value-key="name"
              :debounce="500"
              :fetch-suggestions="querySearch"
              placeholder="请输入学校名称"
              :trigger-on-focus="false"
              @select="handleSelect"
            />
            <!-- <button class="school-up" @click="$refs.upSchoolInput.click()">本地上传</button> -->
          </div>
          <div class="school-name margin-top-24">校徽预览</div>
          <div :class="['school-logo', logo ? 'active' : '']">
            <img v-if="logo.logo_url || cvDetail.basic_info.school_logo_url" :src="logo.logo_url || cvDetail.basic_info.school_logo_url" alt="">
            <img v-else src="https://files.wondercv.com/cvs/school/default-school-icon.png" alt="" style="height: 48px;">
          </div>
          <div class="school-logo-actions">
            <div class="school-logo-action-button" @click="$refs.upSchoolInput.click()">
              <img src="https://files.wondercv.com/cvs/school/upload-icon.png" class="icon"/>
              <span>本地上传</span>
            </div>
            <div class="school-logo-action-button" v-if="logo.logo_url || cvDetail.basic_info.school_logo_url" @click="handleDeleteLogo">
              <img src="https://files.wondercv.com/cvs/school/delete-icon.png" class="icon"/>
              <span>删除校徽</span>
            </div>
          </div>
          <div class="school-btn">
            <button @click="close">取消</button>
            <button class="active" @click="submit">添加</button>
          </div>
        </div>
      </transition>
    </div>
</template>
<script>
  import {mapState, mapMutations, mapActions} from 'vuex';
  import api from '@/api';
  import { dealSignatrue, dataURLtoBlob, blobToFile } from '@/assets/js/util';
  const oss = require('ali-oss');
  import { uuid } from 'vue-uuid';
  export default {
    name: 'SchoolLogo',
    data() {
      return {
        name: '',
        logo: '',
        type: 0,
        isAdd: false
      };
    },
    computed: {
      ...mapState('editor', ['cvToken', 'cvDetail',]),
      ...mapState('app', ['alertData', 'updateOssOptions']),
      ...mapState('cvs', ['editorCvToken']),
      ...mapState('global', ['ossBeaseOptions']),
      ...mapState('me', [ 'personInfo' ]),
      isMembership(){
        return this.personInfo.is_membership
      },
    },
    watch: {
      'alertData': {
        keep: true,
        immediate: true,
        handler: function (alertData) {
          if (!alertData.show) {
            document.body.style.position = 'initial'
            document.body.style.overflow = 'initial'
          }else{
            document.body.style.position = 'static'
            document.body.style.overflow = 'hidden'
          }
          if (alertData.inputData) {
            this.name = '';
            this.logo = '';
            this.type = 0;
          }
        }
      }
    },
    methods: {
      ...mapMutations('editor',[ 'setCvDetail' ]),
      ...mapActions('manage',[ 'getFilterModule' ]),
      ...mapActions('editor', ['createCvDetail']),
      handleDeleteLogo () {
        this.$store.dispatch('app/setAlertData', { });
        const alertData = {
          show: true,
          type: 'message',
          messageTitle: '删除提示',
          showCancelButton: true, //取消按钮
          showConfirmButton: true, // 确定按钮
          confirmButtonText: '取消',
          cancelButtonText: '删除',
          cancelButtonClass: 'cvs-edit-cancelButtonClass',
          confirmButtonClass: 'cvs-edit-confirmButtonClass',
          messageContent: `
            <p>删除内容将无法还原</p>
            <p style="color: #FF453E">确定要删除校徽吗?</p>
          `,
          confirm: close => {
            setTimeout(() => {
              this.$store.dispatch('app/setAlertData', { show: true, type: 'school' });
            }, 300)
          },
          cancel: async close => {
            close();
            let cvDetail = JSON.parse(JSON.stringify(this.cvDetail));
            let res = await api.cvsEditor.deleteSchoolLogo(this.cvToken);
            if (res.code === 1000) {
              //整理当前模块管理选中数据
              //同步简历信息到vuex中
              cvDetail.basic_info.school_logo_url = null;
              cvDetail.basic_info.school_logo_id = null;
              //校徽信息同步到简历信息中
              this.setCvDetail(cvDetail);
              // //重新整理已选模块
              // this.getMenuList(cvDetail)
              //更新未选择模块
              this.getFilterModule();
            }
            else {
              this.$message.error(res.message);
            }
          }
        };
        setTimeout(() => {
          this.$store.dispatch('app/setAlertData', alertData);
        }, 300)
      },
      // cancel() {
      //   this.alertData.cancel && this.alertData.cancel(this.close);
      //   // this.close();
      // },
      // confirm() {
      //   this.alertData.confirm && this.alertData.confirm(this.close, this.value);
      // },
      //上传之前验证
      beforeFileUpload(file) {
        const fileTypes = 'image/png,image/gif,image/jpeg,image/tif,image/tiff,image/bmp,image/x-bmp'
        const isJPG = fileTypes.indexOf(file.type)>-1;
        const isLtMaxSize = file.size / 1024 / 1024 < 1;
        if (!isJPG) {
          this.$message.error('上传校徽格式错误!');
          return false;
        }
        if (!isLtMaxSize) {
          this.$message.error('上传校徽大小不能超过 1MB!');
          return false;
        }
        return true;
      },
      //上传图片回掉
      upInputChange(file) {
        let fileData = file.target.files[0];
        if(!this.beforeFileUpload(fileData)){
          this.$refs.upSchoolInput.value = '';
          return false;
        }
        // 获取图片base64
        let reader = new FileReader();
        reader.readAsDataURL(fileData);
        reader.onload = (event) => {
          console.log(event)
          let url = event.target.result;
          let logo_name = `${uuid.v1()}.${fileData.type.split('/')[1]}`
          this.logo = {
            logo_url: url,
            logo_name
          };
          //清空名称
          this.name = '';
          this.type = 1;
        }
      },
      async submit() {
        if (this.isAdd) return;
        this.isAdd = true;
        let { logo_name, logo_url, id } = this.logo;
        if (!logo_url) {
          this.isAdd = false;
          this.$message.error('请选择学校logo');
          return false;
        }

        if(!this.isMembership){
          this.$message.error("该功能为会员专享");
          // 买会员
          this.buyMember()
          return
        }
        let cvDetail = JSON.parse(JSON.stringify(this.cvDetail));
        const { kind } = cvDetail.basic_info
        let ossRes = {};
        // type == 0 选择， 1 上传
        if (this.type === 1) {
          let store = await oss(this.ossBeaseOptions);
          //调用
          var blob = dataURLtoBlob(logo_url);
          var fileData = blobToFile(blob, logo_name);
          try {
            ossRes = await store.put(`cv/school_logs/${logo_name}`, fileData)
          } catch (error) {
            this.isAdd = false;
            this.$message.error('图片上传失败');
            return false;
          }
          console.log(ossRes)
          if (ossRes.res.statusCode!==200) {
            this.isAdd = false;
            this.$message.error('图片上传失败');
            return false;
          }
          logo_url = ossRes.url;
        }

        //更新信息
        cvDetail.basic_info.school_logo_url = logo_url;
        cvDetail.basic_info.school_logo_id = id || null;
        if (kind === 'template' || kind === 'sample') {
          this.createCvDetail({ payload: cvDetail })
          this.close()
        } else {
          this.updateCvSchoolLogo(cvDetail)
        } 
      },
      // // 无简历创建简历添加校徽
      // async createCvBySchoolLogo(cvDetail) {
      //   this.createCvDetail({})
      // },
      // 有简历增加校徽
      async updateCvSchoolLogo(cvDetail) {
        try {
          // let data = {
          //   operation_type:'update_basic_info',
          //   basic_info: cvDetail.basic_info
          // }
          // let res = await api.cvsEditor.updatedCvInfo(this.cvToken, data);
          let data = {
            school_logo_url: cvDetail.basic_info.school_logo_url,
            school_logo_id: cvDetail.basic_info.school_logo_id,
          }
          let res = await api.cvsEditor.updateVipMembershipInfo(this.cvToken, data);
          if(res.code === 1000){
            //同步简历到vuex中
            this.setCvDetail(cvDetail);
            //重新整理模块管理选中模块
            this.getFilterModule();
            this.$message.success('校徽添加成功');
            this.close();
          }else{
            if(res.code === 600213){
              // 买会员
              this.buyMember()
            }
            this.$message.error(res.message);
          }
        } catch (error) {
          console.log('error=>>',error)
          this.$message.error('校徽添加失败');
        }
        this.isAdd = false;
      },
      // 搜索
      async querySearch(val, cb) {
        let res = await api.cvsEditor.getSchoolLogo(this.cvToken, { school_name: val });
        if (res.code !== 1000) {
          this.$message.error(res.message);
          return false;
        }
        let arr = res.data.logos;
        cb(arr);
      },
      // 选择校徽
      async handleSelect(value) {
        this.logo = value;
        this.type = 0;
      },
      //关闭
      close() {
        this.$store.dispatch('app/setAlertDataShow', false);
      },
      // 去买会员
      buyMember(){
        this.$store.dispatch('app/setAlertData', {
          show: true,
          type: 'upVip',
          browseType: 'schoolLogo'
        })
      },
    }
  }
</script>
<style lang="scss" scoped>
  .school-alert-main {
    width: 0;
    height: 0;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    .cover {
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, .5);
      position: fixed;
      top: 0;
      left: 0;
    }
    .box {
      height: fit-content;
      background: #fff;
      border-radius: 4px;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }
    .school {
      width: 440px;
      padding: 32px;
      box-sizing: border-box;
      min-height: 100px;
      .up-input {
        width: 0;
        height: 0;
        opacity: 0;
        position: absolute;
        top: 0;
        left:0;
      }
      .margin-top-5 {
        margin-top: 5px;
      }
      .margin-top-29 {
        margin-top: 29px;
      }
      .school-title {
        font-size: 20px;
        color: #404040;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .iconfont{
          font-weight: 500px;
          color: #9c9c9c;
          cursor: pointer;
          &:hover{
            color: #404040;
          }
        }
      }
      .school-name {
        font-size: 14px;
        color: #404040;
        span {
          font-size: 12px;
          color: #9c9c9c;
        }
      }
      .school-input {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;
        .inline-input {
          // width: 248px;
          height: 44px;
          border: 1px solid #DEDFE1;
          border-radius: 2px;
          box-sizing: border-box;
          flex: 1;
          border-radius: 4px;
        }
        .school-up {
          display: block;
          background: #fff;
          width: 110px;
          height: 36px;
          border: 1px solid #FF4F4C;
          font-size: 14px;
          color: #FF4F4C;
          border-radius: 2px;
          position: relative;
          &::after {
            content: "（文件小于1MB）";
            display: block;
            width: 100%;
            height: 40px;
            line-height: 40px;
            position: absolute;
            bottom: -100%;
            left: 0;
            font-size: 12px;
            color: #9c9c9c;
          }
        }
      }
      .school-logo-actions{
        display: flex;
        margin-top: 18px;
        .school-logo-action-button {
          display: flex;
          align-items: center;
          width: fit-content;
          color: #404040;
          cursor: pointer;
          margin-right: 16px;
          .icon{
            width: 16px;
            height: 16px;
            margin-right: 2px;
          }
          i {
            font-size: 14px;
          }
          &:hover {
            opacity: .8;
          }
        }
      }
      .school-logo {
        width: 100%;
        height: 170px;
        margin-top: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        // background: #FCFCFC;
        border-radius: 4px;
        border: 1px solid #DEDFE1;
        &.active {
          background: #fff;
        }
        img {
          display: block;
          max-width: 100%;
          max-height: 100%;
        }
      }
      .school-btn {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 20px;
        button {
          display: block;
          width: 84px;
          height: 36px;
          background: #fff;
          border: 1px solid #D9D9D9;
          color: #606060;
          font-size: 14px;
          border-radius: 4px;
          &.active {
            border-color:#FF6644;
            background: #FF6644;
            color: #fff;
            margin-left: 16px;
          }
          &:hover{
            opacity: .8;
          }
        }
      }
    }
  }
</style>
<style lang="scss">
  .school-alert-main {
    .school {
      .inline-input,
      .el-input,
      .inline-input input {
        width: 100%;
        height: 100%;
        border: none;
      }
    }
  }
</style>
